import React, { useEffect, useState } from 'react'
import { Button, Divider, Flex, Form, Input, Modal, Typography } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { LeftOutlined } from '@ant-design/icons'
import { ImRadioChecked } from 'react-icons/im'
import { database } from '../../utils/firebase'

const { Title, Text } = Typography
const { TextArea } = Input

const ViewUpdates = () => {
  const [updates, setUpdates] = useState([])
  const [lab, setLab] = useState([])
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [textAreaValue, setTextAreaValue] = useState('')
  const [loading, setLoading] = useState(false)  // State to handle loading when saving the update

  const navigate = useNavigate()
  const { chatID } = useParams()

  // Function to fetch results from Firebase
  const fetchLabResults = (chatID) => {
    database.ref(`labTracking/${chatID}`).once('value', (snapshot) => {
      const response = snapshot.val()
      setLab(response || [])
    })
  }

  const fetchUpdates = (chatID) => {
    database.ref(`labTracking/${chatID}/updates`).once('value', (snapshot) => {
      const response = snapshot.val()
      if (response) {
        const updatesArray = Object.values(response)

        // Sort updates in descending order by timestamp (latest first)
        updatesArray.sort((a, b) => b.timestamp - a.timestamp)

        setUpdates(updatesArray) // Store the sorted updates array in state
      } else {
        setUpdates([])
      }
    })
  }

  useEffect(() => {
    fetchUpdates(chatID)
    fetchLabResults(chatID)
  }, [chatID])

  // Function to handle modal opening
  const showModal = () => {
    setIsModalVisible(true)
  }

  // Function to handle modal closing
  const handleCancel = () => {
    setIsModalVisible(false)
    setTextAreaValue('')  // Clear text area when the modal is closed
  }

  // Function to save the update to Firebase
  const handleSaveUpdate = async () => {
    if (!textAreaValue.trim()) {
      return  // Prevent saving empty updates
    }

    try {
      setLoading(true)
      const newUpdate = {
        doctorName: lab.doctorName || 'Unknown Doctor',  // Get the doctor's name from lab or fallback to 'Unknown Doctor'
        updateText: textAreaValue,
        timestamp: Date.now(),
      }

      // Push new update to Firebase
      await database.ref(`labTracking/${chatID}/updates`).push(newUpdate)

      setLoading(false)
      setIsModalVisible(false)  // Close modal after saving
      setTextAreaValue('')  // Clear text area after saving
      fetchUpdates(chatID)  // Fetch updates again to display the latest
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  return (
    <div>
      <Flex
        align="center"
        style={{ backgroundColor: '#FFF3F2', padding: '10px 12px', borderBottom: '3px solid #DF7467' }}
      >
        <Button type="text" size="small" icon={<LeftOutlined />} onClick={() => navigate(-1)} />
        <Title style={{ padding: 0, margin: 0 }} level={5}>
          Updates
        </Title>
      </Flex>
      <Flex gap="small" style={{ padding: '8px' }}>
        <Text strong style={{ marginLeft: '10px' }}>
          {lab.patientName}
        </Text>
        <Text>Diagnosis- {lab.assessment}</Text>
      </Flex>
      <Divider style={{ margin: 0 }} />

      <Flex justify="flex-end" gap="small" style={{ padding: '10px' }}>
        <Button type="primary" size="small" shape="round" onClick={showModal}>
          + Add Updates
        </Button>
      </Flex>

      {/* Directly display the updates */}
      <div>
        {updates.length > 0 ? (
          updates.map((update, index) => (
            <div key={index} style={{ padding: '5px', borderBottom: '1px solid #ddd', marginBottom: '10px' }}>
              <Flex
                justify={'space-between'}
                style={{
                  paddingRight: '10px',
                  color: '#DF7467',
                  alignItems: 'center',
                }}
                gap="small"
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                  <ImRadioChecked style={{ marginLeft: '10px', fontSize: '15px' }} />
                  <Text strong> Dr. {update.doctorName} </Text>
                </div>
                <Text>{new Date(update.timestamp).toLocaleString()}</Text>
              </Flex>

              <Flex style={{ alignItems: 'center', gap: 'small', marginBottom: '10px' }}>
                <Text style={{ paddingLeft: '20px' }}>{update.updateText}</Text>
              </Flex>
            </div>
          ))
        ) : (
          <p>No updates yet</p>
        )}
      </div>

      {/* Modal for adding updates */}
      <Modal
        title="Add Update"
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={handleSaveUpdate}
        okText="Save Updates" // name of the button
        confirmLoading={loading}  // Show loading state while saving
        okButtonProps={{ disabled: !textAreaValue.trim() }}
      >
        <Form>
          <Form.Item>
            <TextArea
              rows={4}
              value={textAreaValue}
              onChange={(e) => setTextAreaValue(e.target.value)}
              placeholder="Enter details..."
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default ViewUpdates
